// src/app/redux/sagas/niveauSkillSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    fetchNiveauSkillsRequest,
    fetchNiveauSkillsSuccess,
    fetchNiveauSkillsFail,
    createNiveauSkillSuccess,
    createNiveauSkillFail,
    updateNiveauSkillSuccess,
    updateNiveauSkillFail,
    deleteNiveauSkillSuccess,
    deleteNiveauSkillFail,
    setNiveauSkillLoading,
} from "../actions/niveauSkillActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchNiveauSkillsSaga() {
    const url   = `${API_BASE_URL}/api/niveau-skills`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauSkillLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchNiveauSkillsSuccess(resp.data));
    } catch (e) {
        yield put(fetchNiveauSkillsFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setNiveauSkillLoading(false));
    }
}

export function* createNiveauSkillSaga(action) {
    const url   = `${API_BASE_URL}/api/niveau-skills`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauSkillLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid, token });
        yield put(createNiveauSkillSuccess(resp.data));
        yield put(fetchNiveauSkillsRequest());
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau ajouté", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(createNiveauSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur ajout niveau", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setNiveauSkillLoading(false));
    }
}

export function* updateNiveauSkillSaga(action) {
    const { id, payload } = action.payload;
    const url   = `${API_BASE_URL}/api/niveau-skills/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauSkillLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateNiveauSkillSuccess(resp.data));
        yield put(fetchNiveauSkillsRequest());
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau modifié", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateNiveauSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur modification niveau", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setNiveauSkillLoading(false));
    }
}

export function* deleteNiveauSkillSaga(action) {
    const { id } = action.payload;
    const url   = `${API_BASE_URL}/api/niveau-skills/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauSkillLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteNiveauSkillSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau supprimé", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteNiveauSkillFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression niveau", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setNiveauSkillLoading(false));
    }
}